var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivacyPolicyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18390",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18390",
    transform: "translate(-33 -498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-lock",
    d: "M10.927,1a5.184,5.184,0,0,0-5.2,5.2v.866A1.737,1.737,0,0,0,4,8.793v8.659a1.737,1.737,0,0,0,1.732,1.732H16.122a1.737,1.737,0,0,0,1.732-1.732V8.793a1.737,1.737,0,0,0-1.732-1.732V6.2A5.184,5.184,0,0,0,10.927,1Zm0,1.732A3.392,3.392,0,0,1,14.391,6.2v.866H7.464V6.2A3.392,3.392,0,0,1,10.927,2.732Zm0,8.659A1.732,1.732,0,1,1,9.2,13.122,1.737,1.737,0,0,1,10.927,11.391Z",
    transform: "translate(32 498)",
    fill: "#A59785"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_11075",
    "data-name": "\\u9577\\u65B9\\u5F62 11075",
    width: 20,
    height: 20,
    transform: "translate(33 498)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicyIcon);
export default __webpack_public_path__ + "static/media/privacy-policy_icon.51b8c9d5fcb8137382449569f4a8745d.svg";
export { ForwardRef as ReactComponent };